<template>
  <b-modal :active.sync="isActive" :width="1000">
    <div class="card">
      <div class="card-content">
        <div class="level">
          <div class="level-left is-size-6 has-text-weight-bold has-text-grid-1">
            Budget par régie
          </div>
          <div class="level-right is-size-6 has-text-grid-1">
              <div class="level-item">
                <p class="has-text-weight-bold">
                  Nombre de panneaux: {{ totalNbPanneauxOld + totalNbPanneauxNew }}
                </p>
              </div>
              <div class="level-item ml-5">
                  <p class="has-text-weight-bold">
                    Budget {{type}}: {{ formatNombre(totalRecom)}}
                  </p>
              </div>
          </div>
        </div>
        <div class="block" v-if="type === 'groupe'">
          <b-checkbox v-model="enseigneaAfficher"
            v-for="ens in enseignes" :key="ens.id"
            :native-value="ens.id"
            @input="genereRegies">
            {{ens.libelle}}
          </b-checkbox>
        </div>
        <div class="content">
          <div class="cumul_regie b-table">
            <table class="mb-0 table is-bordered">
              <th class="regie" colspan="2">
                
              </th>
              <th class="left" colspan="3">
                <div class="th-wrap is-size-7 has-text-grid-1 has-text-weight-bold">
                    {{ totalNbPanneauxNew }} 
                    <span class="has-text-weight-normal pa-5"> Nouveaux panneaux </span>
                    ({{ formatNombre(totalBudgetNewPann) }})
                </div>
              </th>
              <th class="right" colspan="3">
                <div class="th-wrap is-size-7 has-text-grid-1 has-text-weight-bold">
                    {{ totalNbPanneauxOld }}
                    <span class="has-text-weight-normal pa-5"> Panneaux sous contrat </span>
                    ({{ formatNombre(totalBudgetOldPann) }})
                </div>
              </th>
            </table>
          </div>
          <b-table :data="regies" height="500" sticky-header bordered class="mb-6">
            <b-table-column v-for="(column, index) in columns"
              :key="index"
              :label="column.label"
              v-bind="column"
              v-slot="props"
              header-class='is-size-7 has-text-grid-1 pa-10 has-text-weight-bold'>
              <span v-if="['budgetOldPann', 'budgetNewPann', 'total'].includes(column.field)">
                {{ formatNombre(props.row[column.field]) }}
              </span>
              <span v-else>
                {{ props.row[column.field] }}
              </span>
            </b-table-column>
          </b-table>
          
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <b-button class="mt-50 has-text-default" @click="isActive = false" type="is-transparent">
                  Fermer
                </b-button>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <download-csv class="button pointer mt-50 has-text-white is-primary"
                  :data="dataRegieExport"
                  :labels="labelsRegies"
                  separator-excel
                  :fields="[
                    'name',
                    'nbPanneauxNew',
                    'budgetNewPann',
                    'nbPanneauxOld',
                    'budgetOldPann',
                    'total',
                    'totalPanneaux'
                  ]"
                  name = "exportRegie.csv">
                  Export tableau
                </download-csv>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { formatNombre, arrondiResult } from '@/services/general/general';

export default {
  props: {
    modalIsActive: Boolean,
    recoms: Array,
    type: String,
    enseignes: Array,
  },
  data() {
    return { 
      columns: [
        {
          field: 'name',
          label: 'Régie',
          'cell-class': 'is-size-7 has-text-default px-20'
        },
        {
          field: 'nbPanneauxNew',
          label: 'Nb de panneaux',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-weight-bold'
        },
        {
          field: 'budgetNewPann',
          label: 'Budget Net HT',
          'cell-class': 'is-size-7 has-text-default px-20'
        },
        {
          field: 'nbPanneauxOld',
          label: 'Nb de panneaux',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-weight-bold'
        },
        {
          field: 'budgetOldPann',
          label: 'Budget Net HT',
          'cell-class': 'is-size-7 has-text-default px-20'
        },
        {
          field: 'totalPanneaux',
          label: 'Total Panneaux',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-weight-bold'
        },
        {
          field: 'total',
          label: 'Total budget net HT',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-weight-bold'
        },
      ],
      recom: [],
      regies: [],
      labelsRegies: {
        name: 'Regie',
        nbPanneauxNew: 'Nb Nouveaux panneaux',
        budgetNewPann: 'Budget net HT Nouveaux panneaux',
        nbPanneauxOld: 'Nb de Panneaux sous contrat',
        budgetOldPann: 'Budget net HT Panneaux sous contrat',
        total: 'Total',
        totalPanneaux: 'Total budget net HT',
      },
      totalRecom: 0,
      totalBudgetNewPann: 0,
      totalBudgetOldPann: 0,
      totalNbPanneauxOld: 0,
      totalNbPanneauxNew: 0,
      enseigneaAfficher: [],
    };
  },
  watch: {
    async isActive(val) {
      if (val) {
        this.enseigneaAfficher = this.enseignes.map(ens => ens.id);
        this.genereRegies();
      }
      else {
        this.recom = [];
        this.regies = [];
        this.totalRecom = 0;
        this.totalBudgetNewPann = 0;
        this.totalBudgetOldPann = 0;
        this.totalNbPanneauxOld = 0;
        this.totalNbPanneauxNew = 0;
      }
    }
  },
  computed: {
    isActive: {
      get() {
        return this.modalIsActive;
      },
      set(value) {
        this.$emit('modalIsClose', value);
      },
    },
    dataRegieExport() {
      return this.regies.map(regie => ({
        ...regie,
        budgetOldPann: arrondiResult(regie.budgetOldPann).toString().replace('.', ','),
        budgetNewPann: arrondiResult(regie.budgetNewPann).toString().replace('.', ','),
        total: arrondiResult(regie.total).toString().replace('.', ',')
      }))
    }
  },
  methods: {
    genereRegies() {
      this.totalRecom = 0;
      this.totalBudgetNewPann = 0;
      this.totalBudgetOldPann = 0;
      this.totalNbPanneauxOld = 0;
      this.totalNbPanneauxNew = 0;
      const panneaux = this.recoms
        .filter(recom => this.enseigneaAfficher.includes(recom.data.pointDeVentes[0].idEnseigne))
        .map(recom => recom.data.pointDeVentes[0].panneaux).flat()
        .map(el => ({
          regie: el.regie,
          ancienPanneau: el.ancienPanneau,
          budgetNetHT: el.budgetAnnuel.prixNet,
          tlpe: el.budgetAnnuel.tlpe,
        }));
      const regieEtPanneaux = [...new Set(panneaux.map(el => el.regie))].map(el => ({
        regie: el,
        ancienPanneaux: panneaux.filter(panneau => panneau.regie === el && panneau.ancienPanneau.toUpperCase() === 'OUI'),
        nouveauPanneaux: panneaux.filter(panneau => panneau.regie === el && panneau.ancienPanneau.toUpperCase() === 'NON'),
      }));
      const regies = [];
      regieEtPanneaux.forEach(regie => {
        let budgetOldPann = 0;
        let budgetNewPann = 0;
        regie.ancienPanneaux.forEach(pan => {
          budgetOldPann += pan.budgetNetHT + pan.tlpe;
        });
        regie.nouveauPanneaux.forEach(pan => {
          budgetNewPann += pan.budgetNetHT + pan.tlpe;
        });
        regies.push({
          name: regie.regie,
          budgetOldPann: budgetOldPann,
          budgetNewPann: budgetNewPann,
          nbPanneauxOld: regie.ancienPanneaux.length,
          nbPanneauxNew: regie.nouveauPanneaux.length,
          total: budgetOldPann + budgetNewPann,
          totalPanneaux: regie.ancienPanneaux.length + regie.nouveauPanneaux.length
        });
        this.totalRecom += budgetOldPann + budgetNewPann;
        this.totalBudgetNewPann += budgetNewPann;
        this.totalBudgetOldPann += budgetOldPann;
        this.totalNbPanneauxOld += regie.ancienPanneaux.length;
        this.totalNbPanneauxNew += regie.nouveauPanneaux.length;
      });
      this.regies = regies.sort((a, b) => a.name.localeCompare(b.name));
    },
    formatNombre(nombre) {
      if (!nombre) return formatNombre(0);
      return formatNombre(nombre);
    },
  },
  mounted() {
  }
}
</script>

<style>

</style>